import React, {useState} from "react";
import {css} from "@emotion/css";
import RaikoCustomTable from "../../raikoComponents/raikoCustomTable/RaikoCustomTable";
import RaikoLabel from "../../raikoComponents/raikoCustomLabel/RaikoLabel";

const ReportTable = () => {
    const [reportListData, setReportListData] = useState([
        prepareTableRowsData(0, 1, "فلان", "فلانی", 25),
        prepareTableRowsData(0, 2, "فلان", "فلانی", 24),
        prepareTableRowsData(0, 3, "فلان", "فلانی", 15),
        prepareTableRowsData(0, 4, "فلان", "فلانی", 35),
        prepareTableRowsData(0, 5, "فلان", "فلانی", 80),
        prepareTableRowsData(0, 6, "فلان", "فلانی", 42),
    ]);
    return (
        <section className={css`display: flex;
          flex-direction: column;
          margin-top: 16px;`}>
            <RaikoLabel text={"عنوان لیست گزارشات"}/>
            <div className={`default-card-container-background-style 
                        ${css`
              padding: 1rem 0;
              margin-top: 1rem;
              overflow-x: hidden !important;
            `}`}>
                <RaikoCustomTable data={reportListData} isLoading={false} header={tableHeader}/>
            </div>
        </section>
    )
}
export default ReportTable
const tableHeader = [
    {id: 'number', label: '#'},
    {id: 'firstName', label: 'نام'},
    {id: 'lastName', label: 'نام خانوادگی'},
    {id: 'age', label: 'سن'},
]


function prepareTableRowsData(id, number, firstName, lastName, age) {
    return {
        id: id,
        number: number,
        lastName: firstName,
        firstName: lastName,
        age: age
    }
}
